import { render, staticRenderFns } from "./Go.vue?vue&type=template&id=86f724d2&scoped=true"
import script from "./Go.vue?vue&type=script&lang=js"
export * from "./Go.vue?vue&type=script&lang=js"
import style0 from "./Go.vue?vue&type=style&index=0&id=86f724d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f724d2",
  null
  
)

export default component.exports